import { apiFetch } from './api';

export interface Sugestao {
  id: string;
  texto: string;
  votosPositivos: number;
  votosNegativos: number;
  meuVoto?: boolean | null; // null = não votou, true = positivo, false = negativo
  creationTime?: string;
  lastUpdateTime?: string;
}

export interface SugestaoRQ {
  texto: string;
}

export interface VotoSugestaoRQ {
  sugestaoId: string;
  isPositivo: boolean;
}

export interface SugestaoQueryRQ {
  dataCriacaoInicio?: string;
  dataCriacaoFim?: string;
  dataAtualizacaoInicio?: string;
  dataAtualizacaoFim?: string;
  votosPositivosMin?: number;
  votosPositivosMax?: number;
  votosNegativosMin?: number;
  votosNegativosMax?: number;
  orderBy?: string; // "votosPositivos", "votosNegativos", "dataCriacao"
  ascending?: boolean;
}

export const sugestoesApi = {
  getAll: async (): Promise<Sugestao[]> => {
    return apiFetch<Sugestao[]>('/Sugestao/GetAll', { auth: true });
  },

  getById: async (id: string): Promise<Sugestao> => {
    return apiFetch<Sugestao>(`/Sugestao/Get/${id}`, { auth: true });
  },

  create: async (sugestao: SugestaoRQ): Promise<Sugestao> => {
    return apiFetch<Sugestao>('/Sugestao/Create', {
      method: 'POST',
      auth: true,
      body: JSON.stringify(sugestao),
    });
  },

  delete: async (id: string): Promise<void> => {
    return apiFetch<void>(`/Sugestao/Delete/${id}`, {
      method: 'DELETE',
      auth: true,
    });
  },

  query: async (query: SugestaoQueryRQ): Promise<Sugestao[]> => {
    return apiFetch<Sugestao[]>('/Sugestao/Query', {
      method: 'POST',
      auth: true,
      body: JSON.stringify(query),
    });
  },

  vote: async (voto: VotoSugestaoRQ): Promise<Sugestao> => {
    return apiFetch<Sugestao>('/Sugestao/Vote', {
      method: 'POST',
      auth: true,
      body: JSON.stringify(voto),
    });
  },
};

